import React, {useEffect, useState} from 'react';
import Translate, {t} from "../../../../../../../../../components/Translate";
import Input from "../../../../../../../../../components-new/form/Input";
import BlueButton from "../../../../../../../../../components-new/buttons/BlueButton";
import SilverButton from "../../../../../../../../../components-new/buttons/SilverButton";
import config from "../../../../../../../../../config";
import {getAiApiKeyStatus, updateAiApiKey} from "../../../../../../../../../services/company/api";
import AiBlock from "./AiBlock";

const errorKeyOf = (error) =>
    error && error.response && typeof error.response.data === 'string'
        ? error.response.data
        : "somethingWentWrong";

const AiApiKey = ({client, aiType, user, addNotification}) => {

    const isSupported = aiType === config.AITypes.GPT_AI || aiType === config.AITypes.GEMINI_AI;

    const [status, setStatus] = useState(null);
    const [draftKey, setDraftKey] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        let active = true;

        if (!isSupported) return;

        getAiApiKeyStatus(client.id)
            .then(data => {
                if (active) setStatus(data);
            })
            .catch(() => {
            });

        return () => {
            active = false;
        };
    }, [client.id, aiType]);

    const save = (value) => {
        setIsSaving(true);

        updateAiApiKey(client.id, value)
            .then(data => {
                setStatus(data);
                setDraftKey('');
                addNotification("successful", config.notificationLevels.success);
            })
            .catch(error => addNotification(errorKeyOf(error), config.notificationLevels.error))
            .finally(() => setIsSaving(false));
    };

    const hasOwnKey = !!(status && status.ownKeyMask);
    const sharedAvailable = !!(status && status.sharedKeyAvailable);

    // the guard sits after the hooks on purpose: returning earlier would change the
    // number of hooks between renders, and React fails the whole screen when the
    // company switches its AI type in the selector above
    // Team AI signs its requests with our own service token, so a company has
    // nothing to supply there
    if (!isSupported) return null;

    return (
        <AiBlock titleKey="aiApiKey" hintKey="aiApiKeyHint">
            <div className="ai-key">
                <div className={'ai-key__notice ai-key__notice--' + (hasOwnKey ? 'own' : sharedAvailable ? 'shared' : 'missing')}>
                    {hasOwnKey
                        ? <Translate text="aiApiKeyUsingOwn"/>
                        : sharedAvailable
                            ? <Translate text="aiApiKeyUsingShared"/>
                            : <Translate text="aiApiKeyNoneAvailable"/>}
                </div>

                {hasOwnKey && (
                    <div className="ai-key__current">
                        <Translate text="aiApiKeyCurrent"/>: <code>{status.ownKeyMask}</code>
                    </div>
                )}

                <div className="ai-key__row">
                    <Input
                        type="password"
                        style={{flex: '1 1 260px'}}
                        placeholder={t({text: 'aiApiKeyPlaceholder', user})}
                        value={draftKey}
                        onChange={(e) => setDraftKey(e.target.value)}
                        disabled={isSaving}
                    />

                    <BlueButton
                        width={'auto'}
                        height={'40px'}
                        styles={{minWidth: '150px', padding: '0 20px', whiteSpace: 'nowrap'}}
                        disabled={!draftKey.trim() || isSaving}
                        onClick={() => save(draftKey.trim())}
                    >
                        <Translate text={hasOwnKey ? 'aiApiKeyReplace' : 'aiApiKeySave'}/>
                    </BlueButton>

                    {hasOwnKey && (
                        <SilverButton
                            width={'auto'}
                            height={'40px'}
                            styles={{padding: '0 20px', whiteSpace: 'nowrap'}}
                            disabled={isSaving}
                            onClick={() => save('')}
                        >
                            <Translate text="aiApiKeyRemove"/>
                        </SilverButton>
                    )}
                </div>
            </div>
        </AiBlock>
    );
};

export default AiApiKey;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/configurations/components/AI/AiApiKey.jsx